import { useAuth } from '../contexts/AuthContext';

/**
 * GST Invoicing & eWarranty access level.
 *
 *   No access   — neither key: the screens are not in the menu at all
 *   View only   — can_view_invoices: read the lists and records, print the PDF
 *                 and the certificate, change nothing
 *   Full access — can_manage_invoices: everything, as before
 *
 * Deleting a GST invoice or a warranty is the master admin's alone.
 */
export const useInvoiceAccess = () => {
  const { user } = useAuth();
  const isMaster = Boolean(user?.is_master_admin);
  const perms = user?.permissions || {};
  const canEdit = isMaster || Boolean(perms.can_manage_invoices);
  const canView = canEdit || Boolean(perms.can_view_invoices);
  return { canView, canEdit, canDelete: isMaster, isMaster, viewOnly: canView && !canEdit };
};

export const ViewOnlyTag = () => (
  <span
    className="text-[10px] uppercase tracking-wider font-semibold text-slate-600 bg-slate-100 border border-slate-200 rounded-full px-2 py-0.5"
    data-testid="view-only-tag"
  >
    View only
  </span>
);

export default useInvoiceAccess;
